import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RecoilRoot } from 'recoil';
import { useBaseConfig } from '../contexts/config';
import { DebugObserver } from './DebugObserver';
export function RecoilProvider(props) {
    const config = useBaseConfig();
    return (_jsxs(RecoilRoot, { children: [config.debug && _jsx(DebugObserver, {}), props.children] }));
}
